import { InputAdornment } from '@mui/material';

import { Iconify } from '@components/Iconify';

const SearchAdornment = () => (
  <InputAdornment position="start">
    <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
  </InputAdornment>
);

export default SearchAdornment;
